import { useTranslation } from 'react-i18next';

type IncidentDetailDelayContentProps = {
  notificationSendDelaySeconds: number;
  startTime: number;
  isCurrentlyActive: boolean;
  useTimer(
    startTime: number,
    delayTimeSeconds: number,
    isActive: boolean,
  ): { hour: number; min: number; sec: number };
};

export function IncidentDetailDelayContent({
  notificationSendDelaySeconds,
  startTime,
  isCurrentlyActive,
  useTimer,
}: IncidentDetailDelayContentProps) {
  const { t } = useTranslation();
  let { min, sec } = useTimer(startTime, notificationSendDelaySeconds, isCurrentlyActive);
  if (!isCurrentlyActive) {
    const inactiveDate = new Date(notificationSendDelaySeconds * 1000);
    min = inactiveDate.getUTCMinutes();
    sec = inactiveDate.getUTCSeconds();
  }
  return (
    <div>
      {isCurrentlyActive && (
        <div className="container flex flex-wrap w-max-m">
          <div className="row font-size-xxl color-blue-500">
            <div className="col-4 flex__jc--center col-offset-2">
              {' '}
              {min < 10 ? `0${min}` : min}
            </div>
            <div className="col-4 flex__jc--center"> {sec < 10 ? `0${sec}` : sec}</div>
          </div>
          <div className="row color-blue-500">
            <div className="col-4 flex__jc--center col-offset-2">
              {' '}
              {min > 1 ? 'minutes' : 'minute'}
            </div>
            <div className="col-4 flex__jc--center">
              {' '}
              {sec > 1 ? 'seconds' : 'second'}
            </div>
          </div>
          <div className="row">
            <div className="p-top-m col-12 flex__jc--center">
              {t('incidents.delayMessage')}
            </div>
          </div>
        </div>
      )}

      {!isCurrentlyActive && (
        <div className="container flex flex-wrap w-max-m">
          <div className="row font-size-xxl">
            <div className="col-12 flex__jc--center"> {min}</div>
          </div>
          <div className="row">
            <div className="col-12 flex__jc--center">
              {min > 1 ? 'minutes' : 'minute'}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
